import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
  headingTab: {
    flex: 1.7,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    borderRight: "solid",
    borderRightWidth: 1,
    paddingLeft: "10px",
    textAlign: "center",
  },
  headingTabSmall: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
  },
  headingTabVerySmall: {
    flex: 0.3,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "semibold",
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
  },
  headingTabSmallLast: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    textAlign: "center",
  },
  bodyTabSmall: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
    fontWeight: "semibold",
  },
  bodyTabSmallR: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
    fontWeight: "bold",
  },
  bodyTabVerySmallR: {
    flex: 0.3,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
    fontWeight: "bold",
  },
  bodyTabVerySmall: {
    flex: 0.3,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "center",
    fontWeight: "semibold",
  },
  bodyTabSmallNBB: {
    flex: 0.5,

    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    fontWeight: "bold",
    textAlign: "center",
  },
  bodyTabVerySmallNBB: {
    flex: 0.3,

    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    fontWeight: "bold",
  },
  bodyTabSmallNBBR: {
    flex: 1.7,

    fontSize: "10px",
    padding: 3,

    fontWeight: "bold",

    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "right",
  },
  bodyTabSmallNB: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  bodyTabVerySmallNB: {
    flex: 0.3,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  bodyTabSmallBNB: {
    flex: 0.5,

    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
    textAlign: "right",
  },
  bodyTabVerySmallBNB: {
    flex: 0.3,

    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  bodyTabWidth: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
  },
  bodyTabSmallLast: {
    flex: 0.5,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    textAlign: "center",
    fontWeight: "semibold",
  },
  bodyTabSmallLastNB: {
    flex: 0.5,

    fontSize: "10px",
    padding: 3,
    fontWeight: "semibold",
    textAlign: "center",
  },
  bodyTab: {
    flex: 1.7,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    paddingLeft: "10px",
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "left",
    fontWeight: "semibold",
  },
  bodyTabNB: {
    flex: 1.7,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  bodyTaBbNB: {
    flex: 1.7,

    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  bodyTaBbNBR: {
    flex: 1.7,

    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",

    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "right",
  },
  VerybodyTaBbNB: {
    flex: 0.3,

    fontSize: "10px",
    padding: 3,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  noteTab: {
    flex: 1.7,
    borderBottom: "solid",
    borderBottomWidth: 1,
    fontSize: "9px",
    padding: "3px",
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "left",
    fontWeight: "semibold",
    fontStyle: "italic",

    backgroundColor: "#ffffff",
  },
  bodyTabSmallLastNoBottom: {
    flex: 0.5,
    fontSize: "10px",
    padding: 3,
    textAlign: "right",
    fontWeight: "semibold",
    borderRight: "solid",
    borderRightWidth: 1,
  },
  bodyTabNoBottom: {
    flex: 1.7,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "left",
    fontWeight: "semibold",
  },
  bodyTabVerySmallNoBottom: {
    flex: 0.3,
    fontSize: "10px",
    padding: 3,
    borderRight: "solid",
    borderRightWidth: 1,
    textAlign: "right",
    fontWeight: "semibold",
  },
});

const Table = ({ invoice, isWhite, screen }) => {
  const TotalRoundOff = Math.round(invoice?.grandTotal?.toFixed(2));
  const RoundOffValue = TotalRoundOff - invoice?.grandTotal;
  console.log(invoice);
  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          opacity: isWhite ? 0 : 1,
        }}
      >
        <Text style={styles.headingTabVerySmall}>S.No.</Text>
        <Text style={styles.headingTab}>Description of Goods</Text>
        <Text style={styles.headingTabSmall}>HSN/SAC code</Text>
        <Text style={styles.headingTabSmall}>Quantity</Text>
        <Text
          style={{
            ...styles.headingTabVerySmall,
            fontWeight: "bold",
          }}
        >
          Unit
        </Text>
        <Text
          style={{
            ...styles.headingTabVerySmall,
            fontWeight: "bold",
          }}
        >
          Price
        </Text>
        <Text style={styles.headingTabSmallLast}>Amount</Text>
      </View>
      {invoice?.products?.map((item, index) => (
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
          }}
          key={index}
        >
          <Text
            style={{
              ...styles.bodyTabVerySmall,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {index + 1}.
          </Text>
          <Text
            style={{
              ...styles.bodyTab,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {`${item?.description}`}
            {invoice?.note && (
              <Text style={{ fontSize: "10px" }}>
                {"\n"}
                {`${invoice?.note}`}
              </Text>
            )}
          </Text>
          <Text
            style={{
              ...styles.bodyTabSmall,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {item?.hsn}
          </Text>
          <Text
            style={{
              ...styles.bodyTabSmall,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {item?.quantity}
          </Text>
          <Text
            style={{
              ...styles.headingTabVerySmall,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {item?.unit}
          </Text>
          <Text
            style={{
              ...styles.headingTabVerySmall,
              borderRightWidth: isWhite ? 0 : 1,
              borderBottomWidth: 0,
            }}
          >
            {item?.rate}
          </Text>
          <Text
            style={{
              ...(index === invoice?.products?.length - 1
                ? styles.bodyTabSmallLast
                : styles.bodyTabSmall),
              borderBottomWidth: 0,
            }}
          >
            {item?.amount?.toFixed(2)}
          </Text>
        </View>
      ))}

      {/* Additional Information Section */}

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderBottom: "solid",
          borderBottomWidth: isWhite ? 0 : 1,
        }}
      >
        <Text
          style={{
            ...styles.bodyTabVerySmall,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTab,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
            fontSize: "10px",
          }}
        >
          {invoice?.weight && `Weight: ${invoice?.weight}Kg`}
          {invoice?.weight &&
            invoice?.products?.[0]?.productDescription &&
            "\n"}
          {invoice?.products?.[0]?.productDescription &&
            `Note: ${invoice?.products?.[0]?.productDescription}`}
          {"\n\n"}
          {!isWhite ? `Udyam No: UDYAM-PB-12-0045852` : ""}
          {"\n\n"}
        </Text>
        <Text
          style={{
            ...styles.bodyTabSmall,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabSmall,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
          }}
        ></Text>
        <Text
          style={{
            ...styles.headingTabVerySmall,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
          }}
        ></Text>
        <Text
          style={{
            ...styles.headingTabVerySmall,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: 0,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabSmallLast,
            borderBottomWidth: 0,
          }}
        ></Text>
      </View>

      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text style={styles.bodyTaBbNB}> </Text>
        <Text style={{ ...styles.bodyTabSmallBNB, opacity: isWhite ? 0 : 1 }}>Total</Text>
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text
          style={{
            ...styles.bodyTabSmallNBB,
            borderRightWidth: isWhite ? 0 : 1,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabSmallLastNB,
          }}
        >
          {" "}
          {invoice?.preGstTotal?.toFixed(2)}
        </Text>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text style={styles.bodyTaBbNB}> </Text>
        <Text style={{ ...styles.bodyTabSmallBNB, opacity: isWhite ? 0 : 1 }}>Add: CGST</Text>
        <Text style={styles.bodyTabVerySmallBNB}></Text>
        <Text
          style={{
            ...styles.bodyTabSmallNBB,
            borderRightWidth: isWhite ? 0 : 1,
          }}
        >
          @ {((invoice?.cgst / invoice?.preGstTotal) * 100)?.toFixed(2)} %
        </Text>
        <Text style={styles.bodyTabSmallLastNB}>
          {" "}
          {invoice?.cgst?.toFixed(2)}
        </Text>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Text
          style={{
            ...styles.bodyTabVerySmallNB,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabNB,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabVerySmallNB,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        >
          {" "}
        </Text>
        <Text
          style={{
            ...styles.bodyTabSmallNB,
            borderBottomWidth: isWhite ? 0 : 1,
            opacity: isWhite ? 0 : 1,
          }}
        >
          Add: SGST
        </Text>
        <Text
          style={{
            ...styles.bodyTabVerySmallNB,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        ></Text>
        <Text
          style={{
            ...styles.bodyTabSmallR,
            borderRightWidth: isWhite ? 0 : 1,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        >
          @ {((invoice?.sgst / invoice?.preGstTotal) * 100)?.toFixed(2)} %
        </Text>
        <Text
          style={{
            ...styles.bodyTabSmallLast,
            borderBottomWidth: isWhite ? 0 : 1,
          }}
        >
          {" "}
          {invoice?.sgst?.toFixed(2)}
        </Text>
      </View>
      {RoundOffValue !== 0 && (
        <View
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Text
            style={{
              ...styles.bodyTabVerySmallNB,
              borderBottomWidth: isWhite ? 0 : 1,
            }}
          ></Text>
          <Text
            style={{
              ...styles.bodyTabNB,
              borderBottomWidth: isWhite ? 0 : 1,
            }}
          ></Text>
          <Text
            style={{
              ...styles.bodyTabVerySmallNB,
              borderBottomWidth: isWhite ? 0 : 1,
            }}
          >
            {" "}
          </Text>
          <Text
            style={{
              ...styles.bodyTabSmallNB,
              flex: 1.2,
              borderBottomWidth: isWhite ? 0 : 1,
              opacity: isWhite ? 0 : 1,
            }}
          >
            Add: Rounded Off ({RoundOffValue > 0 ? "+" : "-"})
          </Text>
          <Text
            style={{
              ...styles.bodyTabVerySmallNB,
              borderBottomWidth: isWhite ? 0 : 1,
            }}
          ></Text>
          <Text
            style={{
              ...styles.bodyTabSmallR,
              borderBottomWidth: isWhite ? 0 : 1,
              borderRightWidth: isWhite ? 0 : 1,
            }}
          ></Text>
          <Text
            style={{
              ...styles.bodyTabSmallLast,
              flex: 0.6,
              borderBottomWidth: isWhite ? 0 : 1,
            }}
          >
            {Math.abs(RoundOffValue)?.toFixed(2)}
          </Text>
        </View>
      )}
      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Text style={styles.VerybodyTaBbNB}></Text>
        <Text
          style={{
            ...styles.bodyTabSmallNBBR,
            borderRightWidth: 0,
          }}
        ></Text>
        <Text style={styles.bodyTabSmallBNB}></Text>
        <Text style={styles.VerybodyTaBbNB}></Text>
        <Text style={styles.VerybodyTaBbNB}></Text>

        <Text
          style={{
            ...styles.bodyTaBbNBR,
            borderRightWidth: isWhite ? 0 : 1,
            opacity: isWhite ? 0 : 1,
          }}
        >
          Grand Total
        </Text>
        <Text
          style={{
            ...styles.bodyTabSmallLast,
            borderBottomWidth: isWhite ? 0 : 1,
            flex: 0.67,
          }}
        >
          {" "}
          {TotalRoundOff?.toFixed(2)}
        </Text>
      </View>
    </View>
  );
};

export default Table;
